import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index.js";
import i18n from "./i18n/index.js";
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";
import VueMarkdown from "vue-markdown";

import "./registerServiceWorker";
import "./index.css";
import "./css/reset.scss";
import "./css/fonts.scss";
import "./css/utils.scss";
import "./css/main.scss";

import "./plugins/font-awesome";
import "./plugins/analytics";
import "./plugins/touch";
import "./plugins/storyblok";
import "./plugins/map";
import "./plugins/moment";
import "./plugins/scroll-reveal";
import "./plugins/smooth-scroll";
import "./plugins/calendar";
import "@/plugins/cookies";
import "./plugins/markdown";
import "./plugins/shop";
import "@/plugins/tooltip";

Vue.config.productionTip = false;

const requireComponent = require.context(`./components/Base`, true, /[\w-]+\.vue$/);
requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName);

  const componentName = upperFirst(camelCase(fileName.replace(/^\.\//, "").replace(/\.\w+$/, "")));
  Vue.component(componentName, componentConfig.default || componentConfig);
});

const requireLayout = require.context(`./layouts`, true, /[\w-]+\.vue$/);
requireLayout.keys().forEach(fileName => {
  const layoutConfig = requireLayout(fileName);

  const layoutName = upperFirst(
    camelCase(fileName.replace(/^\.\//, "").replace(/\.\w+$/, "")) + "Layout"
  );
  Vue.component(layoutName, layoutConfig.default || layoutConfig);
});
Vue.use(VueMarkdown);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
